import {inject, Injectable} from '@angular/core';
import {Observable, shareReplay} from 'rxjs';
import {MEAL_PLAN_GATEWAY} from './meal-plan-gateway';
import {MealPlanSlot} from './meal-plan-slot.model';

/**
 * The household's slot catalogue, cached per household for the session.
 *
 * Slots are effectively static per session, so we `shareReplay` — repeated
 * navigations don't refetch.
 *
 * Fetches through `MEAL_PLAN_GATEWAY` rather than `HttpClient` directly so the
 * catalogue rides the same transport seam as entries (single place to swap or
 * intercept), resolving to `GET /households/{id}/meal-plan/slots`.
 */
@Injectable({providedIn: 'root'})
export class MealPlanSlotsService {
  private readonly gateway = inject(MEAL_PLAN_GATEWAY);
  private readonly cache = new Map<number, Observable<MealPlanSlot[]>>();

  /** Ordered slot catalogue for the household. Cached for the session. */
  getSlots(householdId: number): Observable<MealPlanSlot[]> {
    let slots$ = this.cache.get(householdId);
    if (!slots$) {
      slots$ = this.gateway
        .getSlots(householdId)
        .pipe(shareReplay({bufferSize: 1, refCount: false}));
      this.cache.set(householdId, slots$);
    }
    return slots$;
  }
}
